import { memo } from 'react';
import { startCase } from 'lodash';

const Item = ({ btnStyle, selectedStyle, unselectedStyle, handleClick, option, isSelected }) => {
  let { title, icon, label = "" } = option || {}

  return (
    <button
      type="button"
      className={`${btnStyle} ${isSelected ? selectedStyle : unselectedStyle}`}
      onClick={() => handleClick(title)}
    >
      {icon && <span className="mr-2 flex items-center justify-center">{icon}</span>}
      {label || startCase(title)}
    </button>
  )
}

const areEqual = (prevProps: any, nextProps: any) => {
  return (
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.option?.title === nextProps.option?.title
  )
}

export default memo(Item, areEqual);
